import AuthorizationApi from "./api/server/authorization";

let authCache = null;
var fetchUserInfo = async function () {
  if (!authCache) {
    authCache = await AuthorizationApi.auth();
  }
  return authCache || {};
}

export function ResetAuthCache() {
  authCache = null;
}

export async function CheckIfUserIsAdmin() {
  let auth = await fetchUserInfo();
  auth.userrole == "Admin";
}
 CheckIfUserIsAdmin;


export async function CheckIfUserIsEditor() {
  let auth = await fetchUserInfo();
  return auth.userrole == "LyzarEditor" || auth.userrole == "Admin";
}
